import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import PropertyList from './components/PropertyList';
import PropertyDetail from './components/PropertyDetail';
import ProjectList from './components/ProjectList';
import ProjectDetail from './components/ProjectDetail';
import DealInput from './components/DealInput';
import FileCabinet from './components/FileCabinet';
import Notes from './components/Notes';
import TodoList from './components/TodoList';
import DealHistory from './components/DealHistory';
import QuickBooksIntegration from './components/QuickBooksIntegration';
import { FilterProvider } from './components/context/FilterContext';
export function App() {
  return <BrowserRouter data-id="element-0">
      <FilterProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Layout data-id="element-4" />} data-id="element-3">
            <Route index element={<Dashboard data-id="element-6" />} data-id="element-5" />
            <Route path="properties" element={<PropertyList data-id="element-8" />} data-id="element-7" />
            <Route path="properties/:id" element={<PropertyDetail data-id="element-10" />} data-id="element-9" />
            <Route path="projects" element={<ProjectList data-id="element-12" />} data-id="element-11" />
            <Route path="projects/:id" element={<ProjectDetail data-id="element-14" />} data-id="element-13" />
            <Route path="deal-input" element={<DealInput data-id="element-16" />} data-id="element-15" />
            <Route path="deal-history" element={<DealHistory data-id="element-18" />} data-id="element-17" />
            <Route path="file-cabinet" element={<FileCabinet data-id="element-20" />} data-id="element-19" />
            <Route path="notes" element={<Notes data-id="element-22" />} data-id="element-21" />
            <Route path="todos" element={<TodoList data-id="element-24" />} data-id="element-23" />
            <Route path="quickbooks" element={<QuickBooksIntegration data-id="element-26" />} data-id="element-25" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-28" />} data-id="element-27" />
          </Route>
        </Routes>
      </FilterProvider>
    </BrowserRouter>;
}